import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getFutures, FutureDay, raceLink, fmtTime, fmtDateLong } from '../api/feeds';
import { betfairErrorMessage } from '../api/betfair';
import './Feeds.css';

const Futures: React.FC = () => {
  const [days, setDays] = useState<FutureDay[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setError(null);
    try {
      setDays(await getFutures());
    } catch (err) {
      setError(betfairErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="feed">
      <div className="feed-header">
        <div>
          <h1>Futures</h1>
          <div className="feed-sub">Upcoming race meetings with open Betfair markets</div>
        </div>
        <button className="feed-refresh" onClick={load} disabled={loading}>↻ Refresh</button>
      </div>

      {error && <div className="feed-error">{error}</div>}

      {loading && days.length === 0 ? (
        <div className="feed-loading">Loading future meetings…</div>
      ) : days.length === 0 ? (
        <div className="feed-empty">
          <p>No future meetings loaded yet. The Betfair scraper pulls today and tomorrow’s markets.</p>
          <Link to="/">Browse today’s meetings →</Link>
        </div>
      ) : (
        days.map((day) => (
          <div className="future-day" key={day.date}>
            <div className="future-day-head">
              <span className="future-day-date">{fmtDateLong(day.date)}</span>
              <span className="future-day-count">{day.meetings.length} meetings</span>
            </div>
            <div className="feed-grid">
              {day.meetings.map((m) => (
                <Link
                  key={`${day.date}_${m.meeting}`}
                  to={raceLink(m.meeting, 1, m.date)}
                  className="race-card"
                >
                  <div className="race-card-top">
                    <span className="race-card-meeting">{m.meeting}</span>
                    <span className="race-card-race">{m.race_count} races</span>
                  </div>
                  <div className="race-card-bottom" style={{ marginTop: '0.4rem' }}>
                    <span>First jump {fmtTime(m.first_jump)}</span>
                    <span>
                      {m.total_matched > 0
                        ? `$${m.total_matched.toLocaleString('en-AU', { maximumFractionDigits: 0 })} matched`
                        : 'Markets open'}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default Futures;
